module.exports = __webpack_public_path__ + "img/plus-circle.d4547011.svg";